import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Divider } from 'react-native-elements';
import Header from '../../../components/Header';
import ContactCard from '../components/ContactCard';
import ContactForm from '../components/ContactForm';
import ContactInfo from '../components/ContactInfo';
import Footer from '../../../components/Footer';
import './contact.css';

function Contact() {
  return (
    <div>
      <Header />
      <div id="contact-photo" className="hero-photo">
        <h1 className="contact-us">How to contact us.</h1>
      </div>
      <div id="contact-form">
        <ContactForm />
      </div>
      <div>
        <View style={styles.cards}>
          <ContactCard
            title="Hotels &amp; Condos"
            name="Mark Holmes"
            phone="416-994-5399"
            email="mark@zonetail.com"
          />
          <ContactCard
            title="Strategic Partnerships &amp; Advertisers"
            name="Ken Singh"
            phone="416-788-2815"
            email="ken.singh@zonetail.com"
          />
        </View>
      </div>
      <Divider />
      <div>
        <ContactInfo />
      </div>
      <Footer />
    </div>
  );
}

// For the cards
const styles = StyleSheet.create({
  cards: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: 1200,
    paddingHorizontal: 15,
  },
  title: {
    textAlign: 'left',
    color: '#303133',
  },
  icons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

export default Contact;
